export default "__VITE_ASSET__CTXiMj6S__"